"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@mui/styles");
const useStyles = exports.useStyles = (0, _styles.makeStyles)(MUITheme => ({
  logoContainer: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    "& img": {
      width: 172
    },
    "& h5": {
      marginLeft: 11,
      fontWeight: 300,
      letterSpacing: -1,
      lineHeight: "30px",
      color: MUITheme.palette.text.white,
      "@media(max-width:420px)": {
        display: "none"
      }
    }
  }
}));